/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import historyRefresh from '../../history-refresh';
import history from '../../history';

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

function handleClick(props, event) {
  if (props.onClick) {
    props.onClick(event);
  }

  if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
    return;
  }

  if (event.defaultPrevented === true) {
    return;
  }

  event.preventDefault();
  if (props.isForce) {
    historyRefresh.push(props.to);
  } else {
    history.push(props.to);
  }
}

export default function Link(props) {
  const { to, children, newTab, ...attrs } = props;
  if (newTab) {
    attrs.target = '_blank';
  }
  return (
    <a href={to} {...attrs} onClick={e => {
      if (!newTab) { handleClick(props, e) }
    }}>
      {children}
    </a>
  );
}

Link.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  newTab: PropTypes.bool,
};

Link.defaultProps = {
  onClick: null,
  newTab: false,
};
